<template>
  <div
    class="vf-o-notification-toast"
    :class="{ '--show': show, '--error': error }"
    :role="error ? 'alert' : 'status'"
    :aria-live="error ? 'assertive' : 'polite'"
  >
    <span class="vf-o-notification-toast__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path
          v-if="error"
          d="M7.05 5.64 12 10.59l4.95-4.95 1.41 1.41L13.41 12l4.95 4.95-1.41 1.41L12 13.41l-4.95 4.95-1.41-1.41L10.59 12 5.64 7.05z"
        />
        <path v-else d="m9.2 16.6-4.3-4.3 1.4-1.4 2.9 2.9 8.5-8.5 1.4 1.4z" />
      </svg>
    </span>
    <span>{{ error ? errorNotification : messageNotification }}</span>
  </div>
</template>
<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useStore } from "vuex";
const show = ref(false);
const error = ref(false);
const store = useStore();
let unsubscribe: (() => void) | undefined;
let hideTimer: ReturnType<typeof setTimeout> | undefined;
const messageNotification = computed(() => store.getters["notification/get"]);
const errorNotification = computed(() => store.getters["notification/error"]);

const showNotification = (isError: boolean) => {
  error.value = isError;
  show.value = true;
  if (hideTimer) clearTimeout(hideTimer);
  hideTimer = setTimeout(() => {
    show.value = false;
  }, 3000);
};

onMounted(() => {
  unsubscribe = store.subscribe((mutation) => {
    if (mutation.type === "notification/error") {
      showNotification(true);
    }
    if (mutation.type === "notification/add") {
      showNotification(false);
    }
  });
});

onBeforeUnmount(() => {
  unsubscribe?.();
  if (hideTimer) clearTimeout(hideTimer);
});
</script>
